import React from 'react'
import { StatisticsIcon } from './../Icons'
import { object } from 'prop-types'
import { sliceBottomPadding } from '../../util/helper'
import * as Styled from './styles/StatisticsBlock.styles'

const StatisticsBlock = ({ data }) => (
  <Styled.StatisticsBlock
    bottomPaddingAdjustment={sliceBottomPadding(data.bottom_padding_adjustment)}
  >
    <Styled.TextContainer>
      <Styled.Title>{data.header?.text ?? ''}</Styled.Title>
      <Styled.SubTitle>{data.subhead?.text ?? ''}</Styled.SubTitle>
      <Styled.Cite>{data.citation ? data.citation : ''}</Styled.Cite>
    </Styled.TextContainer>
    <Styled.Sign>
      <Styled.IconContainer>
        <StatisticsIcon />
      </Styled.IconContainer>
      <p>{data.statistic_prompt ? data.statistic_prompt : 'Did You Know?'}</p>
    </Styled.Sign>
  </Styled.StatisticsBlock>
)

StatisticsBlock.propTypes = {
  data: object,
}

export default StatisticsBlock
